import { io } from 'socket.io-client';
import { getSocketOrigin } from './utils/runtimeUrls';

// 공개 페이지에서는 소켓 연결 비활성화 (불필요한 리소스 사용 및 다른 클라이언트 새로고침 방지)
const PUBLIC_PATHS = ['/cal', '/public-calendar', '/GuestCalendar', '/guest-conditions'];
const isPublicPage = PUBLIC_PATHS.some(path => window.location.pathname === path)
  || window.location.pathname.startsWith('/artist-page');

// 공개 페이지용 no-op 소켓 (모든 메서드 호출을 무시)
const nullSocket = {
  on: () => nullSocket,
  emit: () => nullSocket,
  off: () => nullSocket,
  connect: () => nullSocket,
  disconnect: () => nullSocket,
  connected: false,
  id: null,
};

if (isPublicPage) {
  // 공개 페이지에서는 소켓 연결하지 않음
  // eslint-disable-next-line no-console
  console.log('[SOCKET] Public page detected, skipping socket connection');
}

const socketUrl = getSocketOrigin();

const socket = isPublicPage ? nullSocket : io(socketUrl, {
  autoConnect: false,
  withCredentials: true,
  transports: ['websocket', 'polling'],
  timeout: 20000,
  forceNew: true,
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionAttempts: 5,
  maxReconnectionAttempts: 5,
  // 배포 환경에서 추가 옵션
  upgrade: true,
  rememberUpgrade: false
});

let socketConsumerCount = 0;

export const acquireSocketConnection = () => {
  if (isPublicPage || socket === nullSocket) {
    return nullSocket;
  }

  socketConsumerCount += 1;

  if (!socket.connected && !socket.active) {
    socket.connect();
  }

  return socket;
};

export const releaseSocketConnection = () => {
  if (isPublicPage || socket === nullSocket) {
    return;
  }

  socketConsumerCount = Math.max(0, socketConsumerCount - 1);

  if (socketConsumerCount === 0 && socket.connected) {
    socket.disconnect();
  }
};

if (!isPublicPage) {
  socket.io.on('reconnect_attempt', () => {
  });

  // 연결 에러 핸들링
  socket.on('connect_error', (error) => {
    console.warn('[SOCKET] Connection error:', error);
    // 배포 환경에서는 더 자세한 로그
    if (process.env.NODE_ENV === 'production') {
      console.warn('[SOCKET] Production connection error details:', {
        message: error.message,
        description: error.description,
        context: error.context,
        type: error.type
      });
    }
  });

  socket.on('disconnect', (reason) => {
    console.warn('[SOCKET] Disconnected:', reason);
  });

  socket.on('reconnect', (attemptNumber) => {
    console.log('[SOCKET] Reconnected after', attemptNumber, 'attempts');
  });

  socket.on('reconnect_error', (error) => {
    console.warn('[SOCKET] Reconnection error:', error);
  });

  socket.on('reconnect_failed', () => {
    console.error('[SOCKET] Reconnection failed');
  });

  // 연결 성공 시 로그
  socket.on('connect', () => {
    console.log('[SOCKET] Connected successfully');
  });
}

export default socket; 
